export const DUPLICATED_MAIL = 'Adresse mail déjà utilisée';
export const TIER_DATA_DUPLICATED = 'Nom de la société existant';
export const INVALID_NUMBER = 'Numéro de téléphone invalide';
export const INVALID_EMAIL_FORMAT = 'Format email invalide';
export const USER_PASSWORD_INSECURE = 'Mot de passe non sécurisé';
export const USER_OLD_PASSWORD_INVALID = "L'ancien mot de passe est erroné";
export const USER_PASSWORD_UNCHANGED =
  "Le nouveau mot de passe doit être diffèrent de l'ancien mot de passe";
export const USER_EMAIL_DUPLICATED = 'Adresse mail existante';
export const MISSING_REQUIRED_DATA_LISTPROFILEACCESS = 'Veuillez associer un profil';
export const ADMINISTRATOR_UNAUTHORIZED = 'Seulement les super admin peuvent lister les admin';
export const CURRENCY_TARIFF_MISMATCH = 'Tarif ne correspond pas au devise';
export const COUNTRY_CODE_DUPLICATED = 'Le code ISO doit être unique';
export const COUNTRY_NAME_DUPLICATED = 'Le nom du pays doit être unique';
export const CURRENCY_CODE_DUPLICATED = 'Ce code est déjà enregistré';
export const ERROR_ROLE_LINK_USER_ACTIF =
  "Impossible de désactiver ce profil d'accès car il est lié à des utilisateurs";
export const INVALID_DATES = 'Période de validité licence invalide';
export const NOT_ADMIN_MUST_HAVE_ROLE =
  'Vous devez soit sélectionner un profil soit cocher Administrateur';
export const USER_LICENCE_REQUIRED = 'Veuillez sélectionner une licence pour le profil magasin';
export const USER_THIRD_PARTY_REQUIRED =
  'Veuillez sélectionner un tiers pour le profil distributeur';
export const INVALID_FACTURATION_UNIT = 'Tier de facturation invalide';
export const THIRD_PARTY_BUSINESS_CODE_DUPLIQUATED = 'Code métier dupliqué';
export const INVALID_SUPPORT_UNIT = 'Tier de support invalide';
export const THIRD_PARTY_DISCOUNT_INVALID = 'La remise ne doit pas dépasser 100%';
export const CLIENT_DISTRIBUTOR_INVALID = "Magasin choisi n'est pas rattaché au distributeur";
export const LICENCE_DISTRIBUTOR_INVALID = 'Distributeur non rattaché à la licence';
export const ERROR_LICENCE_REQUEST_ALREADY_TREATED = 'Demande déja traitée';
export const MISSING_REQUIRED_DATA_TOLICENCES = 'Veuillez sélectionner au moin un magasin';
export const MISSING_REQUIRED_DATA_TOADMINS = 'Veuillez sélectionner au moin un administrateur';
export const MISSING_REQUIRED_DATA_TODISTRIBUTORS = 'Veuillez sélectionner au moin un distributeur';
export const MARK_NAME_DUPLICATED = 'Une entité avec le même nom existe déjà';
export const DOMAIN_NAME_DUPLICATED = 'Une entité avec le même nom existe déjà';
export const CURRENCY_PRECISION_INVALID = 'Précision invalide';
export const CURRENCY_SYMBOL_DUPLICATED = 'Une entité avec le même symbole existe déjà';
export const CURRENCY_NAME_DUPLICATED = 'Une entité avec le même nom existe déjà';
export const DUPLICATED_IDENTITY_GROUP_CODE = 'Code groupe dupliqué';
export const MISSING_REQUIRED_DATA = "Veuillez sélectionner un type de profils d'accès";
export const MISSING_REQUIRED_DATA_USER_PROFILE_TYPE =
  "Veuillez sélectionner un type de profils d'accès";
export const DUPLICATED_CURRENCY_CODE = 'Code ISO déja existant';
export const CURRENCY_NOT_FOUND = "Impossible de trouver l'entité";
export const INVALID_CURRENCY_CODE = 'Code devise invalide';
export const DUPLICATED_CURRENCY_NAME = 'Nom devise dupliqué';
export const DUPLICATED_CURRENCY_SYMBOL = 'Symbole devise dupliqué';
export const DUPLICATED_CURRENCY_GROUP_CODE = 'Code groupe devise dupliqué';
export const DUPLICATED_ARTICLE_SUB_FAMILY_NAME = 'Nom sous famille dupliqué';
export const DUPLICATED_ARTICLE_SUB_FAMILY_CODE = 'Sous famille article code dupliqué';
export const DUPLICATED_ARTICLE_SUB_FAMILY_GROUP_CODE = 'Sous famille article code groupe dupliqué';
export const PARENT_UNIVERSE_NOT_FOUND = 'Parent univer inexistant';
export const DUPLICATED_UNIVERSE_NAME = 'Il y a déjà un univers avec le même nom à ce niveau';
export const DUPLICATED_UNIVERSE_GROUP_CODE = 'Code group univer dupliqué';
export const DUPLICATED_CHARACTERISTIC_NAME = 'Le nom de l\'entité est déjà utilisé';
export const DUPLICATED_CHARACTERISTIC_GROUP_CODE = 'Code groupe charactéristique dupliqué';
export const DUPLICATED_VARIANT_NAME = 'Le nom de l\'entité est déjà utilisé';
export const DUPLICATED_VARIANT_VALUE_NAME = 'Le nom de la valeur est déjà utilisé';
export const DUPLICATED_VARIANT_GROUP_CODE = 'Code groupe variante dupliqué';
export const PARAMETER_NOT_FOUND = 'Paramètre inexistant';
export const ERROR_USER_CAN_NOT_DISABLE_HIMSELF = "L'utilisateur ne peut pas changer son statut";
export const INVALID_IBAN_FORMAT = 'Format IBAN invalide';
export const DUPLICATED_VAT_PROFILE_BUSINESS_CODE = 'Code métier dupliqué';
export const DUPLICATED_TAX_NAME = 'Nom de taxe dupliqué';
export const PARAMETER_CURRENCY_NOT_FOUND = 'Paramètre devise inexistant';
export const DUPLICATED_MAGASIN =
  "Il n'est pas possible de configurer deux profils avec le même magasin";
export const ERROR_READING_FILE = 'Probléme lors de lecture du fichier';
export const MISSING_REQUIRED_DATA_CONTACT_EMAIL = "L'option pour envoyer un email au demandeur est sélectionnée, mais l'email du demandeur n'est pas indiqué";
export const NOT_A_CLIENT = "Le magasin choisi n'est pas de type client";
export const PILOT_LICENCE_HAVE_NO_DOSSIER="Veuillez choisir un autre modèle de dossier"
export const UNAUTHORIZED_TO_ACCESS_ADMINISTRATOR_USER="Vous n'avez pas accès aux données de cet utilisateur"
export const DOSSIER_AFFECTED_TO_ANOTHER_LICENCE="Ce dossier est affecté à une autre licence"
export const INVALID_DATA_LENGTH_SECURITYCODE="Code de sécurité invalide"
export const USER_SECURITY_CODE_WRONG="Code sécurité invalide"
export const USER_SECURITY_CODE_EXPIRED="Code de securité expiré"
export const ZERO_AVAILABLE_PROFILE="Cet utilisateur n'a pas de profil"
export const TARIF_DISABLED="Le tarif sélectionné est désactivé"
export const ZERO_AVAILABLE_LICENCE = "Aucune licence disponible"
export const CAN_NOT_CREATE_DIST_PROFILE="Il n'est pas possible de créer un profil de distributeur non administrateur"
export const CAN_NOT_CREATE_DIST_PROFILE_AFFECTED_TO_OTHER_DIST="Il n'est pas possible de créer un profil de distributeur non administrateur rattaché à un autre distributeur"
export const USER_CAN_NOT_CREATE_ADMINISTRATOR="Il n'est pas possible de rendre ce profil administrateur"
export const MISSING_REQUIRED_DATA_LICENCEID = "Le champ licence est obligatoire"
export const ERROR_MISSING_REQUIRED_DATA_TYPE="Veuillez choisir le type de profil"
export const MISSING_REQUIRED_DATA_ROLE="Veuillez sélectionner un profil"
export const ERROR_MISSING_REQUIRED_DATA_ROLE ="Veuillez sélectionner un profil"
export const ERROR_MISSING_REQUIRED_DATA_DISTRIBUTOR="Veuiller configurer le tier pour pouvoir enregistrer un profil distributeur"
// Si utilisateur connecté est super admin, la liste des profiles contient 2
// profiles autre que (Administrateurs super + Distributeur super) ou (Administrateurs non super + Distributeur super)
export const INVALID_PROFILES_COMBINATION="Vous pouvez pas choisir cette combinaison de profile"
// ADMIN_CREATE_ONLY_SUPER_DIST : Si utilisateur connecté admin non super et tente d'ajouter un profil autre que super distributeur
export const ADMIN_CREATE_ONLY_SUPER_DIST="L'utilisateur admin non super ne peut créer que des super distributeur"
// SUPER_DIST_CREATE_ONLY_DIST : Si utilisateur connecté super distributeur et tente d'ajouter un profil autre que distributeur non super
export const SUPER_DIST_CREATE_ONLY_DIST= "L'utilisateur super distributeur ne peut créer que des distributeur non super"

export const INVALID_DISTRIBUTOR="Distributeur rattaché à un autre distributeur"
export const ROLE_DISABLED="Le rôle sélectionné est désactivé"
export const THIRD_PARTY_DISABLED="Le tiers est désactivé"

export const DUPLICATED_CUSTOMER_NAME_PHONE_EMAIL="Adresse Mail, ou nom ou téléphone dupliqué"
export const VAT_PROFILE_NOT_FOUND="Impossible de trouver l'entité"

export const MARK_DISABLED="La marque est inactive"
export const LOYALTY_PROFILE_NOT_FOUND = "Impossible de trouver l'entité"
export const IDENTITY_NOT_FOUND = "Impossible de trouver l'entité"
export const POSTAL_CODE_NOT_FOUND = "Impossible de trouver l'entité"
export const COUNTRY_NOT_FOUND = "Impossible de trouver l'entité"
export const USER_NOT_FOUND = "Impossible de trouver l'entité"
export const MISSING_REQUIRED_DATA_SCALECODE = "Le champ code section est obligatoire"
export const DUPLICATED_DATA_COLLECT_SECTION_SCALE_CODE = "Code section dupliqué"
export const DUPLICATED_DATA_COLLECT_SECTION_NAME = "Nom section dupliqué"
export const DATA_COLLECT_SECTION_NOT_FOUND = "Impossible de trouver l'entité"
export const VARIANT_NOT_FOUND = "Impossible de trouver l'entité"
export const ARTICLE_FAMILY_NOT_FOUND = "Impossible de trouver l'entité"
export const ARTICLE_SUB_FAMILY_NOT_FOUND = "Impossible de trouver l'entité"
export const MARK_NOT_FOUND = "Impossible de trouver l'entité"
export const CLASSIFICATION_NOT_FOUND = "Impossible de trouver l'entité"
export const CHARACTERISTIC_NOT_FOUND = "Impossible de trouver l'entité"
export const CUSTOMER_FAMILY_NOT_FOUND = "Impossible de trouver l'entité"
export const SUPPLIER_FAMILY_NOT_FOUND = "Impossible de trouver l'entité"
export const CUSTOMER_PROVENANCE_NOT_FOUND = "Impossible de trouver l'entité"
export const BUDGET_LINE_NOT_FOUND = "Impossible de trouver l'entité"
export const PAYMENT_DEADLINE_NOT_FOUND = "Impossible de trouver l'entité"
export const PAYMENT_METHOD_NOT_FOUND = "Impossible de trouver l'entité"
export const DOCUMENT_COMMENT_NOT_FOUND = "Impossible de trouver l'entité"
export const STOCK_OUT_TYPE_NOT_FOUND =  "Impossible de trouver l'entité"
export const ACCOUNTING_PROFILE_NOT_FOUND =  "Impossible de trouver l'entité"
export const TAX_NOT_FOUND =  "Impossible de trouver l'entité"
export const bankAccount =  "Impossible de trouver l'entité"
export const BANK_ACCOUNT_NOT_FOUND =  "Impossible de trouver l'entité"
export const GDRP_CONSENT_CONFIGURATION_NOT_FOUND  =  "Impossible de trouver l'entité"
export const DELIVERY_ZONE_NOT_FOUND =  "Impossible de trouver l'entité"
export const SUPPLIER_NOT_FOUND =  "Impossible de trouver l'entité"
export const CUSTOMER_NOT_FOUND =  "Impossible de trouver l'entité"
export const MISSING_REQUIRED_DATA_NAME = "Nom de données requis manquant"
export const DUPLICATED_DELIVERY_ZONE_NAME = "Le nom de l'entité est déjà utilisé"
export const DUPLICATED_CHARACTERISTIC_VALUE_NAME = "Le nom de la valeur est déjà utilisé"
export const DUPLICATED_MARK_NAME = "Le nom de l'entité est déjà utilisé"
